import React from 'react';
import ProductDescription from './ProductDescription';

const UpdatePaymentResultBanRow = ({ban, tooltipIdPrefix = 'update-payment-result-ban'}) => {
  return (
    <div className='update-payment-result-ban-row'>
      <img src={require('../images/dot.png')} alt='dot' />
      <div className='update-payment-result-ban-row__ban-number'>חשבון {ban.banNumber}</div> |
      <ProductDescription
        productDescriptions={ban.productDescriptions}
        banNumber={ban.banNumber}
        className='update-payment-result-ban-row__product s-title-small'
        tooltipIdPrefix={tooltipIdPrefix}
        showTooltip={false}
      />
    </div>
  );
};

export default UpdatePaymentResultBanRow;
